import { createModel } from "hox";
import { IIMaterielSearch, IMaterielParams, IMaterielDetail, IMaterielInsert, IMaterielUpdate, IMaterielDisable, IMaterielRemove } from "./materielTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, forFind, findOption } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { materielService } from "./materielService"
export const useMaterielModel = createModel(function () {
    const initSearchParams: IMaterielParams = {}
    const initDataSource: IMaterielDetail[] = []
    const initAddParam: IMaterielInsert = { enable: true, branch: "main" }
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IMaterielParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IMaterielDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IMaterielDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<IMaterielInsert>(initAddParam);
    //物料类型参数
    const [materielTypeTree, setMaterielTypeTree] = useState([]);
    const [brandList, setBrandList] = useState<Optios[]>([])
    const [measurementList, setMeasurementList] = useState<Optios[]>([])

    const upDataSearchParam = (upDataParam: IMaterielParams) => {
        console.log(upDataParam)
        setSearchParam({ ...searchParam, ...upDataParam })

    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IMaterielParams) => {
        const searchParams = data ?? searchParam
        console.log(searchParam, data)
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await materielService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    const updataAddParam = (updateParam: IMaterielInsert) => {
        let newUpdateParam = updateParam
        if ("typeCode" in updateParam) {
            let findItem = forFind(materielTypeTree, updateParam.typeCode as string, "code")
            newUpdateParam = { ...updateParam, typeName: findItem?.name, typeNameEn: findItem?.nameEn }
        }
        if ("brandCode" in updateParam) {
            let findItem = findOption(updateParam.brandCode as string, brandList)
            newUpdateParam = { ...updateParam, brandName: findItem?.label, brandNameEn: findItem?.nameEn }
        }
        if ("unitCode" in updateParam) {
            let findItem = findOption(updateParam.unitCode as string, measurementList)
            newUpdateParam = { ...updateParam, unitName: findItem?.label, unitNameEn: findItem?.nameEn }
        }
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: IMaterielDetail) => {
        debugger;
        let newUpdateParam = updateParam
        if ("typeCode" in updateParam) {
            let findItem = forFind(materielTypeTree, updateParam.typeCode as string, "code")
            newUpdateParam = { ...updateParam, typeName: findItem?.name, typeNameEn: findItem?.nameEn }
        }
        if ("brandCode" in updateParam) {
            let findItem = findOption(updateParam.brandCode as string, brandList)
            newUpdateParam = { ...updateParam, brandName: findItem?.label, brandNameEn: findItem?.nameEn }
        }
        if ("unitCode" in updateParam) {
            let findItem = findOption(updateParam.unitCode as string, measurementList)
            newUpdateParam = { ...updateParam, unitName: findItem?.label, unitNameEn: findItem?.nameEn }
        }
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: IMaterielInsert) => {
        const param = {
            ...addParam,
            sourceApp: "mdm",
            enable: params.enable ? 1 : 0
        }
        const { retData, retMsg } = await materielService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const updataDetail = async (params: IMaterielDetail) => {
        const param = {
            ...selectedRow[0],
            enable: params.enable ? 1 : 0
        }
        const { retData, retMsg } = await materielService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const cutDisabled = async (params: IMaterielDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0
        }
        const { retData, retMsg } = await materielService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        addParam,
        materielTypeTree,
        brandList,
        measurementList,
        setSearchParam,
        setMeasurementList,
        setBrandList,
        setDataSource,
        setPage,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled,
        setMaterielTypeTree
    }
});